import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/components/logo-black.png';

const Navbar = () => {
    const [show, setShow] = useState(false);
    const [scrollColor] = useState('bg-white');
    const [scrollShadow, setScrollShadow] = useState(false);
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [isCommunityDropdownVisible, setIsCommunityDropdownVisible] = useState(false);
    const [brands, setBrands] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isCommunityDropdownOpen, setIsCommunityDropdownOpen] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);
    const toggleMobileMenu = () => setShow(!show);
    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
    const toggleCommunityDropdown = () => setIsCommunityDropdownOpen(!isCommunityDropdownOpen);

    // Fetch Brands and Sub-brands
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [brandsRes] = await Promise.all([
                    fetch(`${process.env.REACT_APP_API_URL}/brands`)
                ]);
                const brandsData = await brandsRes.json();
                setBrands(brandsData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    // Scroll Handler
    useEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset >= 64) {
                setScrollShadow(true);
            } else {
                setScrollShadow(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <nav className={`fixed xl:h-[100px] lg:h-[100px] md:h-[100px] h-[70px] 
                grid grid-cols-3 xl:px-10 lg:px-10 md:px-10 px-4 z-20 transition-all duration-300 ${scrollColor} 
                ${scrollShadow ? 'shadow-md' : ''}`}>
                
                {/* Logo Section */}
                <div className="my-auto">
                    <a href="/">
                        <img src={logo} alt="logo" className="xl:w-[25%] w-80 lg:w-[30%] md:w-[50%]" />
                    </a>
                </div>

                {/* Desktop Menu */}
                <div className="my-auto mx-auto">
                    <ul className="hidden xl:flex lg:flex md:flex space-x-8 uppercase">
                        <li className="text-sm tracking-[.15em]"><Link to="/" style={{fontFamily: "Muli"}}>home</Link></li>
                        <li className="text-sm tracking-[.15em]"><Link to="/about" style={{fontFamily: "Muli"}}>about</Link></li>
                        
                        {/* PORTFOLIO WITH UNIFIED HOVER ZONE */}
                        <li 
                            className="relative text-sm tracking-[.15em] cursor-pointer" 
                            onMouseEnter={() => setIsDropdownVisible(true)}
                            onMouseLeave={() => setIsDropdownVisible(false)}
                        >
                            <Link to="/portfolio" style={{fontFamily: "Muli"}}>portfolio</Link>

                            {/* Dropdown Menu */}
                            {isDropdownVisible && (
                                <div className="absolute top-full left-0 bg-white w-[220px] border shadow-xl py-4 transition-opacity duration-300">
                                    {brands.map((brand) => (
                                        <div key={brand._id} className="px-6 py-2 group">
                                            <Link 
                                                to={`/portfolio/${brand.name}`} 
                                                className="block text-sm hover:text-red-500 transition-colors"
                                                style={{fontFamily: "Muli"}}
                                            >
                                                {brand.name}
                                            </Link>
                                            
                                            {/* Sub-portfolios */}
                                            
                                        </div>
                                    ))}
                                </div>
                            )}
                        </li>

                        <li className="text-sm tracking-[.15em]"><Link to="/blog" style={{fontFamily: "Muli"}}>blog</Link></li>
                        
                        {/* COMMUNITY WITH DROPDOWN */}
                        <li 
                            className="relative text-sm tracking-[.15em] cursor-pointer" 
                            onMouseEnter={() => setIsCommunityDropdownVisible(true)}
                            onMouseLeave={() => setIsCommunityDropdownVisible(false)}
                        >
                            <p to="/community" style={{fontFamily: "Muli"}}>community</p>

                            {/* Community Dropdown Menu */}
                            {isCommunityDropdownVisible && (
                                <div className="absolute top-full left-0 bg-white w-[220px] border shadow-xl py-4 transition-opacity duration-300">
                                    <div className="px-6 py-2">
                                        <Link 
                                            to="/community/the-creative-quarters" 
                                            className="block text-sm hover:text-red-500 transition-colors"
                                            style={{fontFamily: "Muli"}}
                                        >
                                            The Creative Quarters
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </li>

                        <li className="text-sm tracking-[.15em]"><Link to="/contact" style={{fontFamily: "Muli"}}>contact</Link></li>
                    </ul>
                </div>

                {/* Right Side / Sidebar Toggle */}
                <div className="hidden xl:flex lg:flex md:flex justify-end my-auto">
                    <button className="flex flex-col items-end" onClick={toggleMenu}>
                        <span className="py-[1.5px] px-6 bg-red-500 mb-1"></span>
                        <span className="py-[1.5px] px-9 bg-red-500"></span>
                    </button>

                    {/* Sidebar Drawer */}
                    <div className={`fixed top-0 right-0 h-full w-[30%] bg-white z-50 transition-transform duration-300 transform shadow-xl ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
                        style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                        <img 
                            className="absolute top-0 right-0 m-6 cursor-pointer" 
                            width="25" height="25" 
                            onClick={toggleMenu} 
                            src="https://img.icons8.com/ios/30/delete-sign--v1.png" 
                            alt="close"/>
                        
                        <div className="px-10 mt-40 mb-10 text-center">
                            <p className="text-custom-gray-text text-sm leading-relaxed" style={{fontFamily: "Muli"}}>
                                Glintz Photography is a multimedia Brand, set up to document and tell African stories of love, culture, and people...
                            </p>
                        </div>
                    </div>
                </div>

                {/* Mobile Hamburger */}
                <div className="flex justify-end my-auto lg:hidden xl:hidden md:hidden">
                    <button className="flex flex-col" onClick={toggleMobileMenu}>
                        <span className="py-[1.5px] px-6 bg-red-500 mb-1"></span>
                        <span className="py-[1.5px] px-9 bg-red-500"></span>
                    </button>
                </div>

                {/* Mobile Dropdown Menu */}
                {show && (
                    <div className="lg:hidden absolute top-[70px] left-0 w-full max-h-[90vh] shadow-lg bg-white overflow-y-auto">
                        <div className="px-6 py-4 space-y-4">
                            <Link to="/" className="block text-base capitalize font-medium">home</Link>
                            <Link to="/about" className="block text-base capitalize font-medium">about</Link>
                            
                            {/* Mobile Portfolio Accordion */}
                            <div>
                                <button onClick={toggleDropdown} className="w-full text-left text-base capitalize font-medium flex justify-between">
                                    portfolio <span>{isDropdownOpen ? '−' : '+'}</span>
                                </button>
                                {isDropdownOpen && (
                                    <div className="pl-4 mt-2 space-y-4 border-l-2 border-red-500">
                                        {brands.map(brand => (
                                            <div key={brand._id}>
                                                <Link 
                                                    to={`/portfolio/${brand.name}`} 
                                                >
                                                    <p className="font-bold text-sm uppercase">{brand.name}</p>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <Link to="/blog" className="block text-base capitalize font-medium">blog</Link>
                            
                            {/* Mobile Community Accordion */}
                            <div>
                                <button onClick={toggleCommunityDropdown} className="w-full text-left text-base capitalize font-medium flex justify-between">
                                    community <span>{isCommunityDropdownOpen ? '−' : '+'}</span>
                                </button>
                                {isCommunityDropdownOpen && (
                                    <div className="pl-4 mt-2 border-l-2 border-red-500">
                                        <Link to="/community/the-creative-quarters" className="block py-1 text-sm text-gray-500">
                                            The Creative Quarters
                                        </Link>
                                    </div>
                                )}
                            </div>

                            <Link to="/contact" className="block text-base capitalize font-medium">contact</Link>
                        </div>
                    </div>
                )}
            </nav>
        </>
    );
};

export default Navbar;